import { render, staticRenderFns } from "./patientsymptoms.vue?vue&type=template&id=43f93bf4&scoped=true&"
import script from "./patientsymptoms.vue?vue&type=script&lang=js&"
export * from "./patientsymptoms.vue?vue&type=script&lang=js&"
import style0 from "./patientsymptoms.vue?vue&type=style&index=0&id=43f93bf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f93bf4",
  null
  
)

export default component.exports